import { useEffect, useState } from "react";
import { makeRequest } from "../makeRequest";

const usePost = (url, reqData) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(200)
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if(Object.keys(reqData).length === 0) return
    const postData = async () => {
      try {
        setLoading(true);
        const res = await makeRequest.post(url, reqData);
        setData(res.data);
        setStatus(res.status)
      } catch (err) {
        setErrorMessage(err.response.data.error.message)
        setStatus(err.response.data.error.status)
        setError(true);
      }
      setLoading(false);
    };
    postData();
  }, [url, reqData]);

  return { data, loading, error, status, errorMessage };
};

export default usePost;
